// extracted by css-extract-rspack-plugin
export default {"container":"IXIZc","filterPillsSection":"P8FhW","filterButtonWithCount":"j1pJ2","filterButtonAttachment":"okjTj"};